import * as React from 'react';
import './index.scss';
// import { StageDefault } from '@/context.ts';
import { fetch, GetGuildRankRsp, RankItem, GuildItem } from '@/fetch.ts';
import Page from '@hooks/web/public/page.tsx';
import None from '@hooks/web/public/none.tsx';
import defaultAvatar from '@images/web/default.png';
import GroupDetail from '@hooks/web/public/groupDetail.tsx';
const { useEffect, useState } = React;
interface Props {
  iStage: number,
  from: number, // 1金牌，2巅峰
  iRevive: number, //1复活，0常规
}
const GroupRank: React.FC<Props> = props => {
  const [current, Current] = useState<number>(0);
  const [pageShow, PageShow] = useState<boolean>(true);
  const [list, List] = useState<GuildItem[]>([]);
  const [lists, Lists] = useState<any>([]);
  const [showList, ShowList] = useState<GuildItem[]>([]);
  const pageChange = (index: number): void => {
    ShowList(list.slice((index) * 5, (index + 1) * 5 >= list.length ? list.length : (index + 1) * 5));
  }
  useEffect(() => {
    PageShow(false);
    List([]);
    ShowList([]);
    fetch.getGuildRank(
      {
        iStage: props.iStage,
        iArea: props.from === 1 ? 5 : current + 1,
        iRevive: props.iRevive,
      },
    )
      .then((rsp: GetGuildRankRsp) => {
        console.log('公会榜单', {
          iStage: props.iStage,
          iArea: props.from === 1 ? 5 : current + 1,
          iRevive: props.iRevive,
        }, rsp);
        PageShow(true);
        List(rsp.vRank.value.slice(0, 25));
        ShowList(rsp.vRank.value.slice(0, 5));
        Lists(rsp.vRsp.value);
      })
  }, [props.iStage, props.iRevive, current])
  const [showToast, ShowToast] = useState<boolean>(false);
  const [groupName, GroupName] = useState<string>('');
  const [groupId, GroupId] = useState<number>(0);
  const [datas, Datas] = useState<any>(null);
  const close = () => {
    ShowToast(false);
    GroupName('');
    GroupId(0);
  }
  return (
    <div
      className={props.from === 1 ? 'web-groupRank1' : 'web-groupRank2'}
    >
      {
        props.from === 2 &&
        <div className='web-groupTab'>
          {
            ['游戏', '娱乐'].map((item: string, index: number) => (
              <div
                className={current === index ? 'groupTabItem on' : 'groupTabItem'}
                key={item}
                onClick={
                  () => {
                    Current(index);
                  }
                }
              >巅峰{item}公会</div>
            ))
          }
        </div>
      }
      <ul className='web-groupList'>
        {
          showList.length !== 0 ?
            (
              showList.map((items: GuildItem, index: number) => (
                <li key={items.lCompanyId}>
                  <div className='rankNoCover'><div className={`no-${items.iRank > 5 ? 'n' : items.iRank}`}>{items.iRank > 5 ? items.iRank : ''}</div></div>
                  <div className={`avatar avatar-${items.iRank > 3 ? 'n' : items.iRank}`}>
                    <img
                      title={items.sCompanyName}
                      src={items.sCompanyLogoUrl}
                      onError={(event: any): void => {
                        event.target.onerror = null;
                        event.target.src = defaultAvatar;
                      }}
                      onClick={
                        () => {
                          ShowToast(true);
                          GroupName(items.sCompanyName);
                          GroupId(items.lCompanyId);
                          Datas(lists[items.iRank - 1]);
                        }
                      }
                    />
                  </div>
                  <div className='groupMsg'>
                    <h1
                      onClick={
                        () => {
                          ShowToast(true);
                          GroupName(items.sCompanyName);
                          GroupId(items.lCompanyId);
                          Datas(lists[items.iRank - 1]);
                        }
                      }
                    ><span>{items.sCompanyName}</span> <a>详情{'>'}</a></h1>
                    {items.sDesc !== '' && <p>{items.sDesc}</p>}
                  </div>
                  <div className='groupMember'>
                    <div className='singles'>
                      {
                        items.vRank.value.map((single: RankItem, index: number) => {
                          if (index > 2) return '';
                          return (
                            <div className='single' key={single.lUid}>
                              <img
                                title={single.sNickName}
                                src={single.sLogoUrl}
                                onError={(event: any): void => {
                                  event.target.onerror = null;
                                  event.target.src = defaultAvatar;
                                }}
                                onClick={(): void => {
                                  window.open('https://m.huya.com/' + single.tJump.iRoomId, '_blank');
                                }}
                              />
                              {
                                single.tJump.iLive !== 0 &&
                                <i
                                  className='living'
                                ></i>
                              }
                            </div>
                          );
                        })
                      }
                    </div>
                    <p>王牌主播</p>
                  </div>
                  <div className='groupScore'>
                    <h1>{items.lScore}</h1>
                    <p>星光值</p>
                  </div>
                </li>
              ))
            ) :
            (
              <None text='暂无公会数据' />
            )
        }
      </ul>
      {
        showToast &&
        <GroupDetail
          close={close}
          groupName={groupName}
          groupId={groupId}
          iStage={props.iStage}
          iArea={props.from === 1 ? 5 : current + 1}
          data={datas}
        />
      }
      <div className='web-pageCover'>
        {
          pageShow &&
          <Page
            pageLen={list.length % 5 === 0 ? list.length / 5 : Math.floor(list.length / 5) + 1}
            setPageIndex={pageChange}
          />
        }
      </div>
    </div>
  )
}

export default GroupRank;